let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4ivXc")).then(() => parcelRequire('fxrUq'));